import Button from '@mui/material/Button';

const MenuTitle = ({ title }: { title: string }) => (
  <Button
    disableRipple
    sx={{
      fontWeight: 'bold',
      lineHeight: '26px',
      letterSpacing: '0.46px',
      fontSize: '15px',
      color: 'rgba(0, 0, 0, 0.87)',
      padding: '0 0 0 8px',
      height: '42px',
      display: 'flex',
      alignItems: 'center',
      width: '100%',
      justifyContent: 'start',
      '&:hover': {
        backgroundColor: 'transparent',
      },
      cursor: 'text',
      textTransform: 'none',
    }}
  >
    <span
      style={{
        WebkitLineClamp: 1 /* number of lines to show */,
        overflow: 'hidden',
        display: '-webkit-box',
        textOverflow: 'ellipsis',
        WebkitBoxOrient: 'vertical',
        textAlign: 'left',
      }}
    >
      {title}
    </span>
  </Button>
);

export default MenuTitle;
